angular.module('app').config(['AppRoutesProvider', '$stateProvider',
    function (AppRoutesProvider, $stateProvider) {
        'use strict';

        var appRoutes = {
            'login': {
                state: 'login',
                route: '/login',
                portalSettings: {
                    hideToolbar: true,
                    toolbarItem: 'login'
                }
            },
            'signout': {
                state: 'signout',
                route: '/signout',
                portalSettings: {
                    hideToolbar: true,
                    toolbarItem: 'signout'
                }
            },
            'tokenLogin': {
                state: 'tokenLogin',
                route: '/login/:token',
                portalSettings: {
                    hideHeader: true,
                    hideToolbar: true
                }
            },
            'statementslogin': {
                state: 'statementslogin',
                route: '/statementslogin',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'landing': {
                state: 'landing',
                route: '/landing',
                portalSettings: { toolbarItem: 'landing' }
            },
            'loginsettings': {
                state: 'loginsettings',
                route: '/loginsettings',
                portalSettings: {
                    hideToolbar: true,
                    toolbarItem: 'settings'
                }
            },
            'navigationDoctors': {
                state: 'navigationDoctors',
                route: '/navigationDoctors',
                portalSettings: { toolbarItem: 'doctors' }
            },
        };

        AppRoutesProvider.setupAppRoutes(appRoutes);

        $stateProvider
            .state(appRoutes.login.state, {
                url: appRoutes.login.route,
                templateUrl: '/app/views/mfa-login.html',
                controller: 'MfaLoginCtrl',
                description: '/Login',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Login'); }
                }
            })
            .state(appRoutes.signout.state, {
                url: appRoutes.signout.route,
                templateUrl: '/app/views/mfa-login.html',
                controller: 'MfaLoginCtrl',
                description: '/Login',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Login'); }
                }
            })
            .state(appRoutes.tokenLogin.state, {
                url: appRoutes.tokenLogin.route,
                controller: 'TokenLoginCtrl',
                description: 'Login with a auth-token',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('TokenLogin'); }
                }
            })
            .state(appRoutes.loginsettings.state, {
                url: appRoutes.loginsettings.route,
                templateUrl: '/app/views/loginsettings.html',
                controller: 'LoginSettingsCtrl',
                description: '/LoginSettings',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Settings'); }
                }
            })
            .state(appRoutes.statementslogin.state, {
                url: appRoutes.statementslogin.route,
                templateUrl: '/app/views/statementslogin.html',
                controller: 'StatementsLoginCtrl',
                description: '/StatementsLogin',
                alternativeLoginRoute : appRoutes.statementslogin.route,
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Login'); }
                }
            })
            .state(appRoutes.landing.state, {
                url: appRoutes.landing.route,
                templateUrl: '/app/views/landing.html',
                controller: 'LandingCtrl',
                description: '/Landing'
            })
            .state(appRoutes.navigationDoctors.state, {
                url: appRoutes.navigationDoctors.route,
                templateUrl: '/app/views/navigation/navigationDoctors.html',
                controller: 'NavigationDoctorsCtrl',
                description: '/Doctors'
            });
    }]);
